import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import BrandLoader from "@/components/feature/BrandLoader";
import BrandLogo from "@/components/feature/BrandLogo";
import { supabase } from "@/lib/supabase";
import { validateOrdinaryPostAuthNext } from "@/lib/authUtils";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handled = useRef(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const code = searchParams.get("code");
    const nextParam = searchParams.get("next");

    (async () => {
      if (!code) {
        setErrorMessage("El enlace no es válido o ya expiró.");
        return;
      }
      const { data, error } = await supabase.auth.exchangeCodeForSession(code);
      if (error) {
        setErrorMessage("No se pudo completar el acceso. Intenta de nuevo.");
        return;
      }
      if (data.redirectType === "recovery") {
        navigate("/auth/reset-password", { replace: true });
        return;
      }
      navigate(validateOrdinaryPostAuthNext(nextParam), { replace: true });
    })();
  }, [navigate, searchParams]);

  if (!errorMessage) return <BrandLoader label="Completando acceso..." />;

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-background-50 px-6 text-center">
      <BrandLogo size={88} />
      <div className="w-full max-w-sm rounded-lg border border-background-200 bg-background-100 p-6">
        <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-error-warning-line text-2xl"></i>
        </div>
        <h1 className="font-heading text-lg font-semibold text-foreground-950">No se pudo completar</h1>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{errorMessage}</p>
        <Link
          to="/login"
          className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-login-box-line text-base"></i>
          Ir al inicio de sesión
        </Link>
      </div>
    </div>
  );
}